import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import QRCode from 'qrcode.react'

type Props = {
  guestAppUrl: string
}

export const GuestAppSection: React.FC<Props> = ({ guestAppUrl }) => {
  const { t } = useTranslation()
  return (
    <div className="guest-app-block">
      <div>
        <div className="title">
          <Trans i18nKey="SelfCheckIn.Information on being in the country can be found on your smartphone" />
        </div>
        <hr className="-normal" />
        <div className="icon-block">
          <div className="help-icon -facility">
            <img src={require('@/static/images/icon_checkout_black.svg')} />
            <span>{t('SelfCheckIn.Facility')}</span>
          </div>
          <div className="help-icon -travel">
            <img src={require('@/static/images/icon_map_black.svg')} />
            <span>{t('SelfCheckIn.Travel')}</span>
          </div>
          <div className="help-icon -wifi">
            <img src={require('@/static/images/icon_wifi_black.png')} />
            <span>Wi-Fi</span>
          </div>
        </div>
      </div>
      <QRCode value={guestAppUrl} size={153} />
    </div>
  )
}
